import * as Yup from 'yup';
import { ITicketTemplate } from '../../services/ticketTemplates/types';

export const createNewTicketTemplateValidationSchema = Yup.object().shape({
  companyId: Yup.string().required('Required'),
});

export const createQuestionsValidationSchema = (ticketTemplate: ITicketTemplate | undefined) => {
  if (!ticketTemplate?.questions) {
    return Yup.object().shape({
      questions: Yup.object().shape({}),
    });
  }

  const questionsSchema: Record<string, any> = {};

  ticketTemplate.questions.forEach(question => {
    if (question.isRequired) {
      questionsSchema[question.id] = Yup.mixed().required('This field is required');
    }
  });

  return Yup.object().shape({
    questions: Yup.object().shape(questionsSchema),
    configurationId: Yup.mixed(),
    companyId: Yup.mixed(),
  });
};
